export const CUSTOM_TOPIC_ERROR_TYPES = [
  'customTopicRequired',
  'forbiddenCharacters',
  'customTopicMinMaxLength',
];
